import { render, staticRenderFns } from "./activity-data.vue?vue&type=template&id=ca1f6a8a&scoped=true&"
import script from "./activity-data.vue?vue&type=script&lang=js&"
export * from "./activity-data.vue?vue&type=script&lang=js&"
import style0 from "./activity-data.vue?vue&type=style&index=0&id=ca1f6a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f6a8a",
  null
  
)

export default component.exports